var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe',{staticClass:"iframe-style",attrs:{"name":"iframe1","srcdoc":_vm.isHttp ? null : _vm.$store.state.iframeURL,"src":_vm.isHttp ? _vm.$store.state.iframeURL : null}})])
}
var staticRenderFns = []

export { render, staticRenderFns }